<template>
    <a-config-provider :theme="antdTheme">
        <router-view />
        <!-- PWA更新提示 -->
        <PWAUpdatePrompt v-if="isProd" />
        <!-- PWA安装提示 -->
        <PWAInstallPrompt v-if="isProd" />
        <!-- 网络状态提示 -->
        <NetworkStatus />
    </a-config-provider>
</template>


<script setup>
// console.log('🔧 [App.vue] 组件开始初始化')

import { onMounted, nextTick, ref, watch } from 'vue'
// console.log('🔧 [App.vue] Vue组合式API导入完成')

import { ConfigProvider } from 'ant-design-vue'
// console.log('🔧 [App.vue] ConfigProvider导入完成')

import useSettingsStore from '@/store/modules/settings'
// console.log('🔧 [App.vue] SettingsStore导入完成')

import { handleThemeStyle } from '@/utils/theme'
// console.log('🔧 [App.vue] 主题工具导入完成')

import PWAUpdatePrompt from '@/components/PWAUpdatePrompt/index.vue'
import PWAInstallPrompt from '@/components/PWAInstallPrompt/index.vue'
import NetworkStatus from '@/components/NetworkStatus/index.vue'
// console.log('🔧 [App.vue] 所有组件导入完成')

// 定义生产环境标识（不能在模板中直接使用import.meta）
const isProd = import.meta.env.PROD
// console.log('🔧 [App.vue] 环境标识:', isProd ? '生产环境' : '开发环境')

// 获取 settings store
// console.log('🔧 [App.vue] 开始获取SettingsStore')
const settingsStore = useSettingsStore()
// console.log('🔧 [App.vue] SettingsStore获取完成')

// 配置 ant-design-vue 主题 - 使用 ref 确保初始化时就有值
// 提供完整的主题配置，确保所有组件都能正确获取主题信息
// 使用函数创建主题配置，确保每次都是新对象，避免引用问题
// console.log('🔧 [App.vue] 开始配置主题')
const createThemeConfig = (primaryColor = '#1890ff') => {
    return {
        token: {
            colorPrimary: primaryColor,
        }
    }
}

// 初始化主题配置，使用默认值确保始终有值
const antdTheme = ref(createThemeConfig())
// console.log('🔧 [App.vue] 主题配置初始化完成')

// 立即设置主题（如果 store 已初始化）
try {
    const storeTheme = settingsStore?.theme
    if (storeTheme) {
        antdTheme.value = createThemeConfig(storeTheme)
    }
} catch (error) {
    // console.warn('获取主题配置失败，使用默认值:', error)
    antdTheme.value = createThemeConfig()
}

// 监听主题变化，更新 ant-design-vue 主题
watch(() => {
    try {
        return settingsStore?.theme
    } catch {
        return '#1890ff'
    }
}, (newTheme) => {
    try {
        const primaryColor = newTheme || '#1890ff'
        antdTheme.value = createThemeConfig(primaryColor)
    } catch (error) {
        // console.warn('更新主题配置失败:', error)
        antdTheme.value = createThemeConfig()
    }
}, { immediate: true })

onMounted(() => {
    // console.log('🔧 [App.vue] 组件已挂载')
    nextTick(() => {
        // console.log('🔧 [App.vue] 开始初始化主题样式')
        try {
            // 初始化主题样式
            handleThemeStyle(settingsStore.theme)
            // console.log('🔧 [App.vue] 主题样式初始化完成')
        } catch (error) {
            console.error('❌ [App.vue] 主题样式初始化失败:', error)
        }
    })
})

// console.log('🔧 [App.vue] 组件初始化完成')
</script>
